import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import {
  LocationChoice,
  renderLocationChoice,
} from '../../../common/components/SearchHeader/types/LocationChoice';
import { SidebarLinkSection } from '../../ResultView/Sidebar/SidebarLinkSection/SidebarLinkSection';
import { makeLinkSpec } from '../../page-seo/makeLinkSpec';
import { LinkSection } from '../LinkSection/LinkSection';
import { LinkSpec } from '../preset-links/helpers';

interface Props {
  filters: FilterChoice;
  locations: readonly LocationChoice[];
  isSidebar?: boolean;
}

export const SuburbLinks = ({ filters, locations, isSidebar = false }: Props) => {
  let topicName = filters.topic?.specialist ?? filters.topic?.treatment ?? 'Practitioners';

  if (topicName === 'GP' && filters.flag === 'telehealth') {
    topicName = filters.onlineAppointments ? 'Online Doctor' : 'Online GP';
  }

  let linkSectionTitle = `Find ${topicName} by location`;

  if (filters.flag === 'telehealth') {
    linkSectionTitle = `Find ${topicName} with Telehealth services by location`;
  }

  const links: LinkSpec[] = locations.map(location =>
    makeLinkSpec({ ...filters, location }, `${topicName} in ${renderLocationChoice(location)}`),
  );

  const sidebarLinkSection =
    links.length > 0 ? <SidebarLinkSection title={linkSectionTitle} links={links} /> : null;

  if (isSidebar) {
    return sidebarLinkSection;
  } else {
    return <LinkSection title={linkSectionTitle} links={links} />;
  }
};
